import { api } from "../../../api/apiSlice";

export const deductionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDeductions: builder.query({
      query: () => ({ url: "/masters/deductions" }),
      providesTags: (result) =>
        result
          ? [
              ...result.map((d) => ({ type: "HrDeductions", id: d.deductionId })),
              { type: "HrDeductions", id: "LIST" },
            ]
          : [{ type: "HrDeductions", id: "LIST" }],
    }),
    getDeduction: builder.query({
      query: (id) => ({ url: `/masters/deductions/${id}` }),
      providesTags: (result, error, id) => [{ type: "HrDeductions", id }],
    }),
    createDeduction: builder.mutation({
      query: (body) => ({ url: "/masters/deductions", method: "POST", data: body }),
      invalidatesTags: [{ type: "HrDeductions", id: "LIST" }],
    }),
    updateDeduction: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/masters/deductions/${id}`,
        method: "PUT",
        data: body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "HrDeductions", id },
        { type: "HrDeductions", id: "LIST" },
      ],
    }),
    deleteDeduction: builder.mutation({
      query: (id) => ({ url: `/masters/deductions/${id}`, method: "DELETE" }),
      invalidatesTags: [{ type: "HrDeductions", id: "LIST" }],
    }),
    // Full-list diff pattern (handoff §9 intro): send the whole desired set
    // of slabs, each row optionally carrying recordGuid (null = new row,
    // present = update in place, omitted = delete) - the API diffs it.
    replaceDeductionDetails: builder.mutation({
      query: ({ id, details }) => ({
        url: `/masters/deductions/${id}/details`,
        method: "PUT",
        data: { details },
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "HrDeductions", id }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetDeductionsQuery,
  useGetDeductionQuery,
  useCreateDeductionMutation,
  useUpdateDeductionMutation,
  useDeleteDeductionMutation,
  useReplaceDeductionDetailsMutation,
} = deductionsApi;
